export const readingPlanConstants = {
	ReadingPlanGetByFilterRequest: "READINGPLAN_GET_BYFILTER_STARTED",
	ReadingPlanGetByFilterSucccess: "READINGPLAN_GET_BYFILTER_COMPLETED",
	ReadingPlanGetByFilterFailure: "READINGPLAN_GET_BYFILTER_FAILED",

	ReadingPlanDetailRequest: "READINGPLAN_GET_DETAIL_STARTED",
	ReadingPlanDetailSuccess: "READINGPLAN_GET_DETAIL_COMPLETED",
	ReadingPlanDetailFailure: "READINGPLAN_GET_DETAIL_FAILED",

	ReadingPlanSaveRequest: "READINGPLAN_SAVE_STARTED",
	ReadingPlanSaveSuccess: "READINGPLAN_SAVE_COMPLETED",
	ReadingPlanSaveFailure: "READINGPLAN_SAVE_FAILED",

	ReadingPlanDeleteRequest: "READINGPLAN_DELETE_STARTED",
	ReadingPlanDeleteSuccess: "READINGPLAN_DELETE_COMPLETED",
	ReadingPlanDeleteFailure: "READINGPLAN_DELETE_FAILED",

	ReadingPlanDaySaveRequest: "READINGPLANDAY_ADDEDIT_STARTED",
	ReadingPlanDaySaveSuccess: "READINGPLANDAY_ADDEDIT_COMPLETED",
	ReadingPlanDaySaveFailure: "READINGPLANDAY_ADDEDIT_FAILED",

	ReadingPlanCopyRequest: "READINGPLAN_COPY_STARTED",
	ReadingPlanCopySuccess: "READINGPLAN_COPY_COMPLETED",
	ReadingPlanCopyFailure: "READINGPLAN_COPY_FAILED",

	ReadingPlanDayDeleteRequest: "READINGPLANDAY_DELETE_STARTED",
	ReadingPlanDayDeleteSuccess: "READINGPLANDAY_DELETE_COMPLETED",
	ReadingPlanDayDeleteFailure: "READINGPLANDAY_DELETE_FAILED",
}